import { useEffect, useState, memo } from "react";
import moment from "moment";
import { BarChart, Bar, XAxis, ResponsiveContainer, ReferenceLine, LabelList, Cell } from "recharts";
import { DurationBtn } from "@/elements/Button/Button";
import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";
import Actions from "@/elements/Actions";

function NetProfitCard(props) {
    const [data, setData] = useState([]);
    const [duration, setDuration] = useState(0);

    const fetchData = (duration = 0) => {
        axiosInterceptorInstance
            .get(
                `/resources/stock-details/${props.name}/company-financials/${duration === 0 ? "quarterly" : "annual"}/${
                    props.indicator
                }`
            )
            .then((response) => {
                let dataArray = response.data?.data?.reverse()?.map((element) => ({
                    duration: moment(element.duration, "MMM' YYYY").format("MMM 'YY"),
                    value: element.value
                }));
                setData(dataArray);
            });
    };

    useEffect(() => {
        fetchData();
    }, [props]);

    const processedData = data?.map((item) => ({
        ...item,
        dummy: Math.max(...data?.map((item) => item.value)) * 0.015
    }));

    return (
        <div className="mx-3 rounded-xl font-Inter font-medium">
            <ResponsiveContainer width="100%" height={228}>
                <BarChart data={processedData} margin={{ top: 32, right: 0, left: 0, bottom: 8 }}>
                    <XAxis
                        axisLine={false}
                        dataKey="duration"
                        tickLine={false}
                        tick={{
                            color: "#979797"
                        }}
                        tickMargin={16}
                        className="font-Inter font-semibold text-xs"
                    />
                    <Bar dataKey="value" stackId="a" radius={[2, 2, 0, 0]}>
                        {data?.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={`url(#${entry.value >= 0 ? "NetProfit-color-green" : "NetProfit-color-red"})`}
                            />
                        ))}
                        <LabelList
                            dataKey="value"
                            position="top"
                            offset={8}
                            fill="#202020"
                            formatter={(value) =>
                                duration === 0 ? Actions.trimNumber(value) : Actions.trimNumber(value / 10000000)
                            }
                            className="font-Inter font-semibold text-xs"
                        />
                    </Bar>
                    <Bar dataKey="dummy" stackId="a" barSize={1}>
                        {data?.map((entry, index) => (
                            <Cell key={`cell-dummy-${index}`} fill={entry.value >= 0 ? "#2ACF56" : "#FF0000"} />
                        ))}
                    </Bar>
                    <defs>
                        <linearGradient
                            id="NetProfit-color-green"
                            xmlns="http://www.w3.org/2000/svg"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="100%"
                            spreadMethod="reflect"
                        >
                            <stop offset="0" stopColor="#BFF1CC" stopOpacity="1" />
                            <stop offset="1" stopColor="#F0FCF3" stopOpacity="1" />
                        </linearGradient>
                    </defs>
                    <defs>
                        <linearGradient
                            id="NetProfit-color-red"
                            xmlns="http://www.w3.org/2000/svg"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="100%"
                            spreadMethod="reflect"
                        >
                            <stop offset="0" stopColor="#FFF4F4" stopOpacity="1" />
                            <stop offset="1" stopColor="#FFB2B2" stopOpacity="1" />
                        </linearGradient>
                    </defs>
                </BarChart>
            </ResponsiveContainer>
            <div className="flex flex-row justify-center gap-3">
                <DurationBtn
                    active={duration === 0}
                    text="Quarterly"
                    onClick={() => {
                        setDuration(0);
                        fetchData(0);
                    }}
                />
                <DurationBtn
                    active={duration === 1}
                    text="Annual"
                    onClick={() => {
                        setDuration(1);
                        fetchData(1);
                    }}
                />
            </div>
        </div>
    );
}

export default memo(NetProfitCard);
